import { Link } from "react-router-dom";
import { ArrowLeft, ArrowUpRight } from "@phosphor-icons/react";
import { PortfolioSection } from "@/components/PortfolioSection";

export default function Portfolio() {
  return (
    <div className="min-h-screen bg-[#050505] text-[#fafafa]" data-testid="portfolio-page">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#050505]/70 border-b border-[#262626]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm text-[#a3a3a3] hover:text-white" data-testid="portfolio-back-home">
            <ArrowLeft size={16} /> Vision Grafix
          </Link>
          <Link to="/meet" className="text-xs uppercase tracking-[0.2em] text-[#a3a3a3] hover:text-white" data-testid="portfolio-header-meet">
            Book a meeting →
          </Link>
        </div>
      </header>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12">
        <div className="text-[10px] uppercase tracking-[0.4em] text-[#FF2D2D] hero-fade-up hero-delay-1">Portfolio</div>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95] mt-3 max-w-4xl hero-fade-up hero-delay-2" data-testid="portfolio-heading">
          Work we've shipped for brands, ministries &amp; storefronts.
        </h1>
        <p className="text-sm md:text-base text-[#a3a3a3] mt-6 max-w-2xl hero-fade-up hero-delay-3">
          A selection of live websites, e-commerce builds, and brand work delivered by Vision Grafix.
          Every project is scoped and quoted individually.
        </p>
      </section>

      <PortfolioSection />

      <section className="border-t border-[#262626]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <div className="font-display text-3xl md:text-4xl">Have a project in mind?</div>
            <div className="text-sm text-[#a3a3a3] mt-2">Tell us about it and we'll send a tailored quote.</div>
          </div>
          <Link
            to="/register"
            data-testid="portfolio-cta-quote"
            className="btn-primary px-6 py-4 text-sm font-bold uppercase tracking-wider inline-flex items-center gap-2 self-start"
          >
            Request a quote <ArrowUpRight size={16} weight="bold" />
          </Link>
        </div>
      </section>
    </div>
  );
}
